import {ErrorMessage, Field} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import knowledge_icon from '../../../../../../../../../assets/job_postings/icons/knowledge-icon.png';
import {EmpionTextField} from '../../../../../../../../../components/EmpionTextField/EmpionTextField';

export const HardFactsFieldsExperience = () => {
  const {t} = useTranslation();

  return (
    <Grid container display={'flex'} flexDirection={'row'}>
      <Grid item xs={12} display={'flex'} gap={2}>
        <Grid container item xs={12} spacing={1} justifyContent={'space-between'}>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              '& .MuiGrid-item': {
                padding: '0px',
              },
            }}
          >
            <Box component='img' src={knowledge_icon} alt='knowledge_icon' />
            <Field
              type='number'
              name='experience.yearsOfExperience'
              label={`${t('companyJobPostings.newJobDialog.formLabels.yearsOfExperience')}`}
              component={EmpionTextField}
              size={'small'}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              '& .MuiGrid-item': {
                padding: '0px',
              },
            }}
          >
            <Box component='img' src={knowledge_icon} alt='knowledge_icon' />
            <Field
              type='number'
              name='experience.yearsOfLeadership'
              label={`${t('companyJobPostings.newJobDialog.formLabels.yearsOfLeadership')}`}
              component={EmpionTextField}
              size={'small'}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box ml={3}>
          <Typography variant='body2' color='error'>
            <ErrorMessage name='experience' component='span' />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
